// extracted by mini-css-extract-plugin
export default {"root":"uU0OIXFh","nonFullscreen":"DGYR6fDp"};